
import NewApiService from "@/utils/new.api.service";

export default {
  generate(_context, options) {
    return new Promise((resolve, reject) => {
      NewApiService.get("stats/generate", options)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    })
  },
  export(_context, options) {
    return new Promise((resolve, reject) => {
      NewApiService.get(
        "stats/export",
        options,
        //{ responseType: "blob" }
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    })
  }

};
